import axios from 'axios';
import { apiBase } from './apiUrl';

const API = axios.create({
  baseURL: apiBase,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = (data) => API.post('/api/auth/login', data);
export const getMembers = () => API.get('/api/members');
export const getVolunteers = () => API.get('/api/volunteers');
export const getDonations = () => API.get('/api/donations');
export const getBlogs = () => API.get('/api/blogs');
export const getNotifications=()=>API.get('/api/Notifications');
export const getEventSlides=()=>API.get('/api/EventSlides');
export const getContactInfo=()=>API.get('/api/ContactInfo');

